<template>
  <div>
    <infoBackground></infoBackground>
    <a-spin class="spin-box" :spinning="loading">
      <div class="pay-order">
        <div class="pay-title">提交订单成功</div>
        <div class="goods-info">
          <div class="goods-title">{{ goodsInfo?.title }}</div>
          <div class="goods-title goods-price-box">
            <span>{{ pay_success ? '支付金额' : '待支付' }}</span> ：￥
            <span class="goods-price">
              {{ orderInfo?.payMoney }}
            </span>
          </div>
        </div>
        <div class="pay-box" v-if="!pay_success">
          <div class="pay-type">
            <div class="pay-type-item">
              <i class="icon" :class=[payMethods[currentPayMethod].icon]></i>
              <span>{{ payMethods[currentPayMethod].name }}</span>
            </div>
          </div>
          <a-spin class="spin-box" :spinning="isPaying">
            <div class="qrCode-box">
              <vue-qr class="qrCode" :text="payurl" :size="300" v-if="payurl"></vue-qr>
            </div>
          </a-spin>

          <div class="notice">
            <svg class="svg-icon icon-scan">
              <use xlink:href="#icon-saoma" />
            </svg>
            <span>请打开{{ payMethods[currentPayMethod].name }}扫描二维码支付</span>
          </div>
          <div class="return" @click="returnBack">暂不支付</div>
        </div>
        <div class="pay-box finish-box" v-if="pay_success">
          <i class="finish-icon"></i>
          <div class="finish-title">支付成功</div>
          <div class="finish-notice">
            恭喜您已经完成支付，订单
            <span class="waite-time">{{ waitingTime }}s</span>后将自动跳转
          </div>
          <a-button size="large" class="finish-btn" @click="returnBack" type="primary">立即学习</a-button>
        </div>
      </div>
      <!-- 页脚 -->
      <foot v-if="!loading"></foot>
    </a-spin>
  </div>
</template>

<script>
import navroot from "@/component/public/nav/nav.vue";
import foot from "@/component/public/foot/foot.vue";
import VueQr from 'vue-qr/src/packages/vue-qr.vue';
import infoBackground from "@/component/public/info-background/info-background.vue";

export default {
  name: 'payorder',
  components: {
    navroot, VueQr, foot, infoBackground
  },
  data() {
    return {
      orderGuid: '',
      goodsGuid: '',
      couponGuid: null,
      payurl: '',
      formHtml: '',
      waitingTime: 10,

      orderInfo: null,
      goodsInfo: null,
      userInfo: null,
      intPay: null,
      currentStore: null,

      loading: true,
      isPaying: false,
      pay_success: false,
      phoneMode: false,

      currentPayMethod: 0,
      payMethods: [
        { name: '微信支付', type: 'wechatpay', icon: 'wx-icon', value: 0 },
        { name: '支付宝', type: 'alipay', icon: 'zhb-icon', value: 1 }
      ],
    }
  },
  mounted() {
    const { userInfo, phoneMode, currentStore } = this.$store.state;
    this.userInfo = userInfo;
    this.phoneMode = phoneMode;
    this.currentStore = currentStore;

    const { currentPayMethod } = this.$route.query;
    if (currentPayMethod) this.currentPayMethod = currentPayMethod;

    this.findOrder();
  },
  methods: {
    //查找支付订单判断是否支付
    async findOrder() {
      this.orderGuid = this.$route.params.id;
      const res = await this.$api.payorder.findPayOrder({ pk_payorderGuid: this.orderGuid });
      this.loading = false
      if (res.statusCode != 200) return this.$message.error(res.message);

      const data = res.data;
      this.orderInfo = data;
      this.goodsGuid = data.fk_goodsGuid;
      this.goodsInfo = this.$store.state.storeBooks.find(item => item.pk_store_book_id == this.goodsGuid);

      if (this.orderInfo.isPaid) return this.payFinish();
      this.payOff();
    },
    //支付
    async payOff() {
      if (this.isPaying) return;
      this.isPaying = true;
      let orderInfo = this.orderInfo;
      let goodsInfo = this.goodsInfo;
      let returl = ``;
      if (this.phoneMode) returl = `https://lessonplay_view_page.lessonplan.cn/pay-finish/${this.goodsGuid}`;
      //需要支付
      if (goodsInfo.price > 0) {
        const body = {
          pk_payorderGuid: orderInfo.pk_payorderGuid,
          price: orderInfo.payMoney,
          name: goodsInfo.name,
          returl,
          fk_publishing_agency_id: this.currentStore.fk_publishing_agency_id,
          payType: "native"
        }
        //获取支付地址
        let subRes;
        if (this.currentPayMethod == 0) subRes = await this.$api.payorder.wechatSubmitOrder(body);
        else subRes = await this.$api.payorder.aliSubmitOrder(body);

        if (subRes.statusCode != 200) {
          this.isPaying = false;
          return this.$message.error(subRes.message);
        }
        this.payurl = subRes.data.code_url;
        if (this.phoneMode) return location.href = this.payurl;

        //循环兼听支付结果
        this.intPay = setInterval(() => { this.listenPay() }, 3000);
      }
      else this.payFinish();
      this.isPaying = false;
    },
    //兼听支付状态
    async listenPay() {
      let res = await this.$api.payorder.findPayOrder({ pk_payorderGuid: this.orderGuid });
      if (res.statusCode != 200) {
        clearInterval(this.intPay);
        return this.$message.error(res.error);
      }
      else if (res.data?.isPaid) {
        clearInterval(this.intPay);
        this.payFinish();
      }
    },
    //支付成功
    async payFinish() {
      this.pay_success = true;
      //购买成功，更新购买状态
      const { storeBooks } = this.$store.state;
      storeBooks.forEach((item) => {
        if (item.pk_store_book_id === this.goodsGuid) {
          item.isPaid = true;
        }
      })
      this.$store.commit("storeBooks", JSON.parse(JSON.stringify(storeBooks)));

      const that = this;
      const int = setInterval(() => {
        if (that.waitingTime <= 0) {
          clearInterval(int);
          that.returnBack();
        }
        that.waitingTime -= 1;
      }, 1000);
    },
    //返回
    returnBack() {
      clearInterval(this.intPay);
      this.$router.push(`/course-info/${this.goodsGuid}`);
    },
  }
}


</script>

<style scoped lang="scss">
@import "./pay-order.scss";
</style>